import { Link } from 'react-router-dom';
import { usePatient, useStrategy } from '@/store/selectors';

/** Compact patient + strategy context breadcrumb for secondary screens. */
export function Breadcrumb(): JSX.Element {
  const { patient } = usePatient();
  const strategy = useStrategy();
  if (!patient) {
    return (
      <div className="breadcrumb" data-testid="breadcrumb">
        <span className="breadcrumb-item">
          No patient context yet — <Link to="/">go to the Calculator tab</Link> to enter a patient.
        </span>
      </div>
    );
  }
  return (
    <div className="breadcrumb" data-testid="breadcrumb">
      <span className="breadcrumb-item">
        {patient.ageYears}y {patient.sex}
      </span>
      <span className="breadcrumb-sep">·</span>
      <span className="breadcrumb-item">{patient.heightCm}cm / {patient.actualWeightKg}kg</span>
      <span className="breadcrumb-sep">·</span>
      <span className="breadcrumb-item">SCr {patient.scrMgDl} mg/dL</span>
      <span className="breadcrumb-sep">·</span>
      <span className="breadcrumb-item">{strategy.strategy}</span>
    </div>
  );
}
